module.exports = __webpack_public_path__ + "static/media/krypa.50eca7e4.mp3";